const mutations ={
    setExpenseList(state,data){
         state.expenseList=data;
    },
    setExpenseTypeList(state,data){
         state.expenseTypeList=data;
    },
    setExpense(state,data){
            state.expense=data;
    },
    setExpenseType(state,data){
        state.expenseType=data;
    },
    resetExpense(state){
        state.expense ={
            amount : 0,
            paymentModeId : '',
            date : '',
            description :''
        }
    },
    resetExpenseType(state){
        state.expenseType ={
         //   label:'',
        }
    },
    setMonthlyExpenseAmount(state, amount) {
        state.monthlyExpenseAmount = amount;
    }
}

export default mutations;
